import { render } from "./icon-organization.vue?vue&type=template&id=c949a186"
import script from "./icon-organization.vue?vue&type=script&lang=js"
export * from "./icon-organization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__